import React from 'react';
import { FormGroup, FormControl, Button, Input, ColorPicker, Alert } from 'components';
import styles from 'styles/campaign_settings_second_step.module.scss';
import Bundle from './Bundle';
import { CAMPAIGN_TYPES } from 'lib/globals';
import classNames from 'lib/classNames';

const Bundles = ({ context, validationErrors, shopContext }) => {
	const { state: campaign, newBundle } = context;
	return (
		<FormGroup
			className={styles.group}
			label={CAMPAIGN_TYPES['bundles']}
			info="Create rewards for when a customer buys more of certain products."
		>
			<FormControl label="discount title" error={validationErrors['settings.applied_discount_title']}>
				<Input
					autofocus
					placeholder="discount title"
					BindToContext={[context, 'settings.applied_discount_title']}
				/>
			</FormControl>

			<FormControl label="Create offer" marginBottom="mb-0">
				<div className={classNames('flex flex-col')}>
					{campaign.settings.bundles.list.map((bundle, index) => (
						<Bundle bundle={bundle} key={index} index={index} context={context} shopContext={shopContext}/>
					))}
				</div>
			</FormControl>
			<div className={classNames('flex justify-end mb-4')}>
				<Button text="New offer" icon="plus" onClick={() => newBundle()} type="info" />
			</div>
			<Summary campaign={context.state} />
			<FormControl label="offer description" error={validationErrors['settings.bundles.text']}>
				<Input BindToContext={[context, 'settings.bundles.text']} placeholder="offer description" />
			</FormControl>
			<FormControl label="pricing" error={validationErrors['settings.bundles.prefix']}>
				<Input BindToContext={[context, 'settings.bundles.prefix']} placeholder="pricing" />
			</FormControl>
			<FormControl label="font size" error={validationErrors['settings.bundles.font_size']}>
				<Input
					BindToContext={[context, 'settings.bundles.font_size']}
					type="number"
					min={0.5}
					max={2}
					step={0.1}
					placeholder="font size"
				/>
			</FormControl>
			<FormControl
				label="Offer colors"
				error={validationErrors['settings.bundles.background'] || validationErrors['settings.bundles.color']}
			>
				<ColorPicker text="Background" BindToContext={[context, 'settings.bundles.background']} />
				<ColorPicker text="Color" position="bottom right" BindToContext={[context, 'settings.bundles.color']} />
			</FormControl>
			<FormControl
				label="Selected offer colors"
				error={
					validationErrors['settings.bundles.activeBackground'] ||
					validationErrors['settings.bundles.activeColor']
				}
			>
				<ColorPicker text="Background" BindToContext={[context, 'settings.bundles.activeBackground']} />
				<ColorPicker
					text="Color"
					position="bottom right"
					BindToContext={[context, 'settings.bundles.activeColor']}
				/>
			</FormControl>
		</FormGroup>
	);
};

export default Bundles;

const Summary = ({ campaign }) => {
	const {
		target,
		settings: { bundles },
	} = campaign;
	//TODO: i need show money formatting here
	if ((target.type === 'specific_products' && !target.selected.length) || !bundles.list.length) return null;
	const must_truncated = (text) => text.length > 25;
	const truncate_name = (text) => `"${text.substring(0, 25).trim()}${must_truncated(text) ? '...' : ''}"`;
	const product_name = target.type === 'specific_products' ? truncate_name(target.selected[0].title) : 'any product';

	return (
		<Alert type="info" icon="info-circle" title="campaign summary" className={classNames('mb-6')}>
			{bundles.list.map(({ quantity, type, reward }, i) => {
				if (!quantity || !type || !reward) return null;
				const isLast = i === bundles.list.length - 1;
				const formatted_reward = type === 'percentage' ? `${reward}%` : `$${reward}`;
				return (
					<p key={i}>
						{`Buy ${quantity} ${
							isLast ? ' or more' : ''
						} of ${product_name} and get ${formatted_reward} off.`}
					</p>
				);
			})}
		</Alert>
	);
};
